import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import './nav-fix.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
